/**
 * useBuddyGroupRodeos — Fetch rodeos this buddy group is attached to.
 *
 * Wraps GET /buddy-group-ops/:groupId/rodeos. Each entry includes rodeo
 * metadata (name, dates, location, timezone) plus the (group, rodeo)
 * attachment row's locked performance preferences. Sorted upcoming-first
 * by the backend.
 */

import { useQuery } from '@tanstack/react-query';
import { buddyGroupOpsKeys } from '../api/extensions/useBuddyGroupOps';
import { listBuddyGroupRodeos } from '../services/buddy-group.service';
import type { BuddyGroupRodeoEntry } from '../types/buddy-groups';

export const buddyGroupRodeosKeys = {
  forGroup: (groupId: string) =>
    [...buddyGroupOpsKeys.all, 'rodeos', groupId] as const,
};

export function useBuddyGroupRodeos(groupId: string | undefined | null) {
  return useQuery<BuddyGroupRodeoEntry[]>({
    queryKey: buddyGroupRodeosKeys.forGroup(groupId ?? ''),
    queryFn: () => listBuddyGroupRodeos(groupId as string),
    enabled: !!groupId,
    staleTime: 60 * 1000, // 1 min — rodeo metadata changes infrequently
  });
}
